import React from 'react';
import { SignaGlyph } from './SignaGlyph';

/**
 * Chat bubble for the Today timeline. Two variants:
 *   - `pa` (default): left-aligned, SignaGlyph avatar, prose in ink
 *   - `user`:         right-aligned, accent-tinted bubble
 *
 * `thinking` pulses the glyph (used while streaming).
 */

type Variant = 'pa' | 'user';

export interface PAMessageProps {
  variant?: Variant;
  thinking?: boolean;
  children: React.ReactNode;
}

export function PAMessage({ variant = 'pa', thinking = false, children }: PAMessageProps) {
  if (variant === 'user') {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          margin: '18px 0',
        }}
      >
        <div
          style={{
            maxWidth: '72%',
            padding: '10px 14px',
            background: 'var(--user-bubble)',
            color: 'var(--ink)',
            borderRadius: 14,
            borderBottomRightRadius: 4,
            fontSize: 15,
            lineHeight: 1.5,
            whiteSpace: 'pre-wrap',
          }}
        >
          {children}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        gap: 14,
        margin: '20px 0',
        alignItems: 'flex-start',
      }}
    >
      <div
        aria-hidden
        style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          background: 'var(--accent-wash)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          marginTop: 2,
        }}
      >
        <SignaGlyph size={16} pulse={thinking} />
      </div>
      <div
        style={{
          flex: 1,
          paddingTop: 2,
          fontSize: 15,
          color: 'var(--ink)',
          minWidth: 0,
        }}
      >
        {children}
      </div>
    </div>
  );
}
